import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registrar o Service Worker e inscrever para notificações
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('Service Worker registrado com sucesso:', registration);
      // Após o registro, tentar inscrever o usuário
      import('./lib/push').then(({ subscribeUserToPush }) => {
        subscribeUserToPush();
      });
    }).catch(error => {
      console.log('Falha ao registrar o Service Worker:', error);
    });
  });
}
